import { useState } from 'react';
import styles from './styles.module.scss';

import CreateOrder from './CreateOrder/CreateOrder';
import Overview from './Overview/Overview';
import EditOrder from './EditOrder/EditOrder';
import ViewOrder from './ViewOrder/ViewOrder';

export default function Orders() {

  const [managementType, setManagementType] = useState('Overview');
  const [editOrder, setEditOrder] = useState(null);
  const [viewOrder, setViewOrder] = useState(null);

  const [ordersToUpdate, setOrdersToUpdate] = useState([]);

  const addOrderToUpdate = (order) => {
    setOrdersToUpdate((prev) => [...prev, order]);
  };

  const removeUpdatedOrder = (orderID) => {
    setOrdersToUpdate((prev) => prev.filter((order) => order.orderID !== orderID));
  };
  

  return (
    <section id={styles.orderWrapper}>
      <div id={styles.container}>
        { managementType === 'Overview' && <Overview ordersToUpdate={ordersToUpdate} removeUpdatedOrder={removeUpdatedOrder} viewOrder={(orderID) => setViewOrder(orderID) } openCreateOrder={() => setManagementType('Create')} openEditOrder={(orderID) => { setEditOrder(orderID); setManagementType('Edit'); }} /> }
        { managementType === 'Create' && <CreateOrder close={() => setManagementType('Overview')} /> }
        { managementType === 'Edit' && editOrder && <EditOrder orderID={editOrder} close={() => { setEditOrder(null); setManagementType('Overview') } } /> }
        { viewOrder && <ViewOrder orderID={viewOrder} close={() => setViewOrder(null)} addOrderToUpdate={addOrderToUpdate} />}
      </div>
    </section>
  );
}

